function updateCartItemsCount(){
    fetch(window.theme.routes.root + 'cart.js')
    .then(res => res.json())
    .then(res => {
        const itemCount = res.item_count;
        const itemCountElements = window.document.querySelectorAll('[class^="cart-items-count-"');
        if (itemCountElements.length < 1) return;
        itemCountElements.forEach(item => item.innerHTML = itemCount)
    })
    .catch(e => console.error('Error updating cart count',e))
}

window.addEventListener("theme:cart:change",updateCartItemsCount);